// File: src/EnglishTool/verbsPool.js

export function getVerbsPool(grade) {
    switch (grade) {
      case 1:
        // Grade 1 verbs
        return [
          "run", "jump", "eat", "play", "see", "go", "sing", "dance"
        ];
      case 2:
        // Grade 2 verbs
        return [
          "run", "jump", "sing", "dance", "write", "draw", 
          "eat", "sleep", "think", "play"
        ];
      case 3:
        // Grade 3 verbs
        return [
          "talk", "read", "swim", "watch", "ride", 
          "study", "build", "teach", "listen", "help"
        ];
      case 4:
        // Grade 4 verbs
        return [
          "discover", "invent", "compare", "decide", "request", 
          "wait", "carry", "climb", "fix", "calculate"
        ];
      case 5:
        // Grade 5 verbs
        return [
          "analyze", "argue", "celebrate", "explain", "investigate", 
          "observe", "prepare", "produce", "drive", "admire"
        ];
      case 6:
        // Grade 6 verbs
        return [
          "accelerate", "attempt", "classify", "define", "evaluate",
          "juggle", "maintain", "protect", "demonstrate", "confirm"
        ];
      case 7:
        // Grade 7 verbs
        return [
          "criticize", "emphasize", "elaborate", "manipulate", "negotiate",
          "appreciate", "specify", "integrate", "select", "purchase"
        ];
      case 8:
        // Grade 8 verbs
        return [
          "anticipate", "illustrate", "interpret", "organize", "prioritize",
          "supervise", "disrupt", "replicate", "expand", "recall"
        ];
      case 9:
        // Grade 9 verbs
        return [
          "acquaint", "affiliate", "accumulate", "clarify", "collaborate",
          "formulate", "generate", "differentiate", "isolate", "address"
        ];
      case 10:
        // Grade 10 verbs
        return [
          "implement", "facilitate", "unify", "hypothesize", "incorporate",
          "standardize", "optimize", "finalize", "prioritize", "interpret"
        ];
      case 11:
        // Grade 11 verbs
        return [
          "articulate", "conceptualize", "delegate", "rationalize", 
          "revolutionize", "mitigate", "strategize", "transform", 
          "unify", "exemplify"
        ];
      case 12:
        // Grade 12 verbs
        return [
          "orchestrate", "ascertain", "circumvent", "expedite", "galvanize",
          "emulate", "diagnose", "contemplate", "consolidate", "epitomize"
        ];
      default:
        // If no grade matched, return an empty array or a fallback
        return [];
    }
  }
  